// import { Icon } from 'antd';

const POST = 'POST'
const GET = 'GET'

// export const breadcrumbSeparator = <Icon type="caret-right" />;

export const webPrefix = '/worksite'

export const method = { POST, GET }

export const MemberType = { 0: '普通会员', 1: '理事会员', 2: '常务理事会员', 3: '副会长会员' }

export const AccountStatus = {
  [-1]: '未注册',
  0: '上报资料中',
  1: '提交申请中',
  2: '总会审批中',
  3: '分会审批中',
  4: '总会确认中',
  5: '批复中',
  6: '待缴费确认',
  7: '发证中',
  8: '已制证',
  100: '正常',
  101: '冻结',
  99: '欠费',
}

export const paymentStatus = {
  0: '待缴费',
  1: '已缴费',
  2: '欠费',
}
